import { createFileRoute } from '@tanstack/react-router';
import { Schema } from 'effect';
import { ReceptoraPage } from '../../../receptora/connections/receptora-page.tsx';
import { ReceptoraSearch } from '../../../receptora/receptora-search.ts';

// Declared inline: the route plugin splits `component` into a lazy binding it declares after the
// options, so an options object declared on its own reads that binding before it exists in dev.
// The page test mounts `Route.options` (real `validateSearch`, real component) instead.
export const Route = createFileRoute('/receptora/')({
  validateSearch: Schema.toStandardSchemaV1(ReceptoraSearch),
  component: ReceptoraRoute,
});

function ReceptoraRoute(): JSX.Element {
  return <ReceptoraPage search={Route.useSearch()} />;
}
